<script>
  export default {
    props: {
      idx: {
        type: Number,
        default: null
      }
    },
    data () {
      return {
        elList: null,
        elListItems: null,
        scrollRange: 0,
        scrollValue: 0
      }
    },
    computed: {
      atBegin () {
        return this.scrollValue < 1
      },
      atEnd () {
        return this.scrollValue >= this.scrollRange
      }
    },
    mounted () {
      if (!this.$device.isMobile) return false
      this.$nextTick(() => {
        this.initIndicator()
      })
    },
    destroyed () {
      if (!this.elList) return false
      this.elList.removeEventListener('scroll', this.setScrollValue)
    },
    methods: {
      initIndicator () {
        if (!this.$slots.default) return false
        this.elList = this.$slots.default[0].elm
        this.elListItems = this.$slots.default[0].elm.children
        if (!this.elList || !this.elListItems || this.elList.scrollWidth < this.elList.offsetWidth) return false
        const elListItemsLength = this.elListItems.length
        const lastItemWidth = elListItemsLength > 0 ? this.elListItems[elListItemsLength - 1].clientWidth : 0
        this.scrollRange = (this.elList.scrollWidth - this.elList.clientWidth) - (lastItemWidth / 2)
        this.elList.addEventListener('scroll', this.setScrollValue)
      },
      setScrollValue (e) {
        this.scrollValue = e.target.scrollLeft
      },
      handleClick (e) {
        if (!this.$device.isMobile && e.target.tagName !== 'A') return false
        e.target.scrollIntoView({
          behaviour: 'smooth',
          block: 'nearest',
          inline: 'center'
        })
      }
    }
  }
</script>

<template>
  <div
    class="horizontal-navigation relative overflow-x-hidden overflow-y-hidden"
    :class="{ 'show-indicator-begin' : !atBegin, 'show-indicator-end' : !atEnd }"
  >
    <div class="indicator-begin absolute top-0 left-0">
      <q-icon
        name="chevron-left"
        class="relative opacity-25 z-20"
      />
    </div>
    <div
      class="slot-container"
      @click="handleClick"
    >
      <slot />
    </div>
    <div class="indicator-end absolute top-0 right-0">
      <q-icon
        name="chevron-right"
        class="relative opacity-25 z-20"
      />
    </div>
  </div>
</template>

<style lang="scss">

  .horizontal-navigation {

    .slot-container {
      @screen md {
        width: fit-content;
        margin: 0 auto;
      }
    }

    &.show-indicator-begin .indicator-begin {
      opacity: 1;
    }

    &.show-indicator-end .indicator-end {
      opacity: 1;
    }

    .indicator-begin {
      opacity: 0;
      transition: opacity .25s ease(easeOutSine);

      &:before {
        @apply block absolute pointer-events-none z-10 bg-white;
        content: '';
        width: theme('spacing.24');
        height: theme('spacing.12');
        top: -.5rem;
        left: 0;
        background: linear-gradient(90deg, #FFFFFF 4%, rgba(255, 255, 255, 0) 60%);
      }
    }

    .indicator-end {
      opacity: 0;
      transition: opacity .25s ease(easeOutSine);

      &:before {
        @apply block absolute pointer-events-none z-10 bg-white;
        content: '';
        width: theme('spacing.24');
        height: theme('spacing.12');
        top: -.5rem;
        right: 0;
        background: linear-gradient(270deg, #FFFFFF 13.21%, rgba(255, 255, 255, 0) 48.78%);
      }

    }

  }

</style>
